import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { ScoreRing } from "@/components/OpportunityCard";
import { useAuth } from "@/lib/auth.jsx";

export default function GetMeOut() {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  useEffect(() => { api.get("/get-me-out").then(r => setPlan(r.data)); }, []);
  if (!plan) return <div className="p-8 text-gray-400">Building your plan…</div>;

  return (
    <div className="max-w-3xl mx-auto px-5 pt-6">
      <div className="eyebrow text-[#FD0F10]">GET ME OUT OF HERE</div>
      <h1 className="font-display text-3xl sm:text-4xl font-black mt-1">{user?.name ? `${user.name}, here's your exit plan.` : "Your personalized exit plan."}</h1>
      <p className="text-gray-300 text-sm mt-2">Based on your assessment. Pick one path. Commit for thirty days.</p>

      <div className="mt-6 space-y-3">
        {plan.top_three.map((o, i) => (
          <Link key={o.id} to={`/opportunity/${o.id}`} className="card-panel p-4 flex items-center gap-4 rot-hover" data-testid={`gmo-${o.id}`}>
            <div className="text-[#FD0F10] font-display text-3xl font-black w-8">{i+1}</div>
            <ScoreRing score={o.escape_score} size={52} />
            <div className="flex-1 min-w-0">
              <div className="font-display font-bold">{o.title}</div>
              <div className="text-xs text-gray-400 truncate">{o.tagline}</div>
            </div>
            <span className="text-[#FD0F10] text-xl">→</span>
          </Link>
        ))}
      </div>

      <div className="mt-6 card-panel p-5">
        <div className="eyebrow text-[#FD0F10]">NEXT STEPS</div>
        <ol className="mt-3 space-y-2 list-decimal pl-5 text-sm text-gray-200">
          {plan.next_steps.map((s,i)=><li key={i}>{s}</li>)}
        </ol>
      </div>

      <div className="mt-6 flex gap-2 flex-wrap">
        <Link to="/exit" className="hero-accent px-4 py-3 rounded font-bold" data-testid="gmo-exit">Set Exit Number</Link>
        <Link to="/coach" className="border border-[#2A2E39] px-4 py-3 rounded hover:border-white" data-testid="gmo-coach">Talk to Escape Coach</Link>
      </div>
    </div>
  );
}
